define([
	"dojo/_base/declare",
	"csi/def",
	"csi/heading/Ref",
	"csi/prefs",
	"csi/xml"
], function(declare,def,Ref,prefs,xml) {

	return declare(Ref, {
		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			// summary: return shared custom views for contractual document package cover sheet
			var	node = ctx.getNode();
			var	type = ctx.getParent().$Type;
			h.m_relationship = prefs.getStoreRelationship(def.composeViewKey("CoverSheet","ContractualDocumentPackage",type));
			return this.inherited(arguments);
		}
	});
});